import { AfterViewInit, Component, inject, Input, OnChanges, OnDestroy, OnInit, signal, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'instruction-setup',
  templateUrl: './instruction.component.html',
})
export class InstructionComponent implements OnChanges {
  @Input() currentUser;
  @Input() setupInstructions = [];
  @Input() title = [];
  @Input() hasCustomTitle = false;
  @Input() videoSrc: string = '';
  iframeSrc: SafeResourceUrl;
  private sanitizer = inject(DomSanitizer);

  constructor() {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.loom.com/embed/4b104f21dbac4bdbaf0c0997deefb36e?sid=a798c2fb-a400-48c0-99d3-98c3db18dd27'
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    const { videoSrc } = changes;
    if (videoSrc?.currentValue !== videoSrc?.previousValue) {
      this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(videoSrc?.currentValue);
    }
  }

  updateIframeSrc(newUrl: string) {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(newUrl);
  }
}
